import React from 'react'
import { useDragStore } from './DragContext'

export default ({
  children,
  onDragEnter,
  onDragExit,
  onDrop,
  onDropAccepted,
  disabled,
  accepts,
  ...rest
}) => {
  const { state } = useDragStore()

  const getIsAccepted = () => {
    let isAccepted = false;
    if (accepts) {
      if (Array.isArray(accepts)) {
        if (accepts.includes(state.draggingType)) {
          isAccepted = true;
        }
      } else {
        if (state.draggingType === accepts) {
          isAccepted = true;
        }
      }
    } else {
      isAccepted = true;
    }
    return isAccepted
  }

  const handleDragEnter = () => {
    const isAccepted = getIsAccepted()
    if (onDragEnter) {
      onDragEnter(state.dragData, isAccepted)
    }
  }

  const handleDragExit = () => {
    const isAccepted = getIsAccepted()
    if (onDragExit) {
      onDragExit(state.dragData, isAccepted)
    }
  }

  const handleDrop = () => {
    if (onDrop) {
      onDrop(state.dragData)
    }
    const isAccepted = getIsAccepted()
    if(isAccepted && onDropAccepted){
      onDropAccepted(state.dragData)
    }
  }

  return (
    <div
      {...rest}
      onMouseEnter={state.isDragging && !disabled ? handleDragEnter : undefined}
      onMouseLeave={state.isDragging && !disabled ? handleDragExit : undefined}
      onMouseUp={state.isDragging && !disabled ? handleDrop : undefined}
    >
      {children}
    </div>
  )
}
